export enum SyncStatusEnum{
    true  = 'Synced',
    false = 'Not Synced'
}
